import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="max-w-lg text-center gw-card p-12" data-testid="payment-cancel">
        <XCircle className="w-14 h-14 text-[#8A877B] mx-auto" />
        <h1 className="font-heading text-3xl font-bold text-[#FDFBF7] mt-6">Donation Cancelled</h1>
        <p className="mt-3 text-[#C8C4B7]">No charge was made. Whenever you're ready, the mission is here.</p>
        <Link to="/donate" className="btn-gold inline-block mt-8" data-testid="cancel-retry">Try Again</Link>
      </div>
    </div>
  );
}
